/**
 * Image URL utility functions
 * Handles proper URL resolution for images across the application
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get the full URL for an image path
 * Handles both absolute URLs (http/https) and relative paths
 * @param {string} path - Image path or full URL
 * @returns {string|null} - Full URL or null if no path
 */
export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('data:')) return path; // Base64 data URLs
  return `${BACKEND_URL}${path}`;
};

/**
 * Get avatar URL with fallback handling
 * @param {string} avatarUrl - Avatar path or URL
 * @returns {string|null} - Full URL or null
 */
export const getAvatarUrl = (avatarUrl) => getImageUrl(avatarUrl);

/**
 * Get cover image URL with fallback handling
 * @param {string} coverUrl - Cover image path or URL  
 * @returns {string|null} - Full URL or null
 */
export const getCoverUrl = (coverUrl) => getImageUrl(coverUrl);
